import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const cols = [
  {
    title: "Categorias",
    links: [
      { to: "/loja?categoria=celulares", label: "Celulares" },
      { to: "/loja?categoria=acessorios", label: "Acessórios" },
      { to: "/loja?categoria=telas", label: "Telas de reposição" },
      { to: "/loja", label: "Catálogo completo" },
    ],
  },
  {
    title: "Loja",
    links: [
      { to: "/", label: "Início" },
      { to: "/admin", label: "Painel do administrador" },
      { to: "/payment/success", label: "Confirmar pagamento" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink mt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-10 pt-16 pb-8">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 pb-14 border-b border-white/10">
          <div>
            <Logo />
            <p className="text-mute text-sm leading-relaxed mt-5 max-w-xs">
              Celulares, acessórios e telas de reposição com curadoria de verdade
              e uma experiência de compra em três dimensões.
            </p>
            <p className="text-xs text-mute/70 mt-5">
              contato@vortex.store
            </p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <p className="text-xs uppercase tracking-[0.2em] text-mute mb-5">
                {col.title}
              </p>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/80 hover:text-cyan transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p
          className="font-display font-semibold uppercase text-outline text-[19vw] md:text-[13rem] leading-[0.85] text-center select-none pt-10"
          aria-hidden="true"
        >
          VORTEX
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 text-xs text-mute/70">
          <p>© {new Date().getFullYear()} VORTEX. Todos os direitos reservados.</p>
          <p>Pagamentos processados com segurança pelo Mercado Pago.</p>
        </div>
      </div>
    </footer>
  );
}
